import DaylightChart from 'components/DaylightChart'
import styled from 'styled-components'
// @ts-ignore
import { Scrollama, Step } from 'react-scrollama'
import { throttle } from 'throttle-debounce'
import { useState, useCallback, useMemo } from 'react'
import { useSpring } from '@react-spring/core'
import { StepContent, Strong } from '../../theme/styles'
import { Trans, useTranslation } from 'react-i18next'

const DaylightChartScroll = ({ data }: { data: MyCsvRow[] }) => {
  const { t } = useTranslation()
  const [step, setStep] = useState(0)
  const [pctSpring, pctSpringApi] = useSpring(() => ({
    pct: 270,
  }))

  const handleEnter = useCallback((e: any) => {
    setStep(e.data)
  }, [])
  const handleExit = useCallback((e: any) => {}, [])
  const onStepProgress = useCallback((e: any) => {
    pctSpringApi.start({
      pct: e.progress,
    })
  }, [])

  const throttledHandleScroll = useMemo(
    () => throttle(100, onStepProgress),
    [onStepProgress]
  )

  return (
    <Container>
      <ChartContainer>
        <DaylightChart data={data} step={step} />
      </ChartContainer>
      <ScrollContainer>
        <Scrollama
          offset={1}
          onStepEnter={handleEnter}
          onStepExit={handleExit}
          onStepProgress={throttledHandleScroll}
        >
          <Step data={1}>
            <ScrollytellingStep>
              <StepContainer>
                <StepContent>
                  <p><b>{t('chart:scrollytelling:stage1:title')}</b></p>
                  <p>
                    <Trans
                      i18nKey='chart:scrollytelling:stage1:p1'
                      components={{ Strong: <Strong /> }}
                    />
                  </p>
                  <p>
                    <Trans
                      i18nKey='chart:scrollytelling:stage1:p2'
                      components={{ Strong: <Strong /> }}
                    />
                  </p>
                </StepContent>
              </StepContainer>
            </ScrollytellingStep>
          </Step>
          {/* <Step data={2}>
            <ScrollytellingStep>
              <StepContainer>
                <StepContent>
                  <p>
                    <Trans
                      i18nKey='chart:scrollytelling:stage2:p1'
                      components={{ Strong: <Strong /> }}
                    />
                  </p>
                  <p>{t('chart:scrollytelling:stage2:p2')}</p>
                </StepContent>
              </StepContainer>
            </ScrollytellingStep>
          </Step> */}
          <Step data={3}>
            <ScrollytellingStep>
              <StepContainer>
                <StepContent>
                  <p><b>{t('chart:scrollytelling:stage2:title')}</b></p>
                  <p>{t('chart:scrollytelling:stage2:p1')}</p>
                </StepContent>
              </StepContainer>
            </ScrollytellingStep>
          </Step>
          <Step data={4}>
            <ScrollytellingStep>
              <StepContainer>
                <StepContent>
                  <p><b>{t('chart:scrollytelling:stage3:title')}</b></p>
                  <p>{t('chart:scrollytelling:stage3:p1')}</p>
                  <p>{t('chart:scrollytelling:stage3:p2')}</p>
                </StepContent>
              </StepContainer>
            </ScrollytellingStep>
          </Step>
          {/* <Step data={4}>
            <ScrollytellingStep>
              <StepContainer>
                <StepContent>
                  <p>{t('chart:scrollytelling:stage5:p1')}</p>
                  <p>{t('chart:scrollytelling:stage5:p2')}</p>
                </StepContent>
              </StepContainer>
            </ScrollytellingStep>
          </Step> */}
        </Scrollama>
      </ScrollContainer>
    </Container>
  )
}

const Container = styled.div`
  background-color: #1e2021;
`

const ChartContainer = styled.div`
  position: sticky;
  max-width: 1200px;
  margin: 0 auto;
  top: 0;
`

const ScrollContainer = styled.div``

const ScrollytellingStep = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
`

const StepContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.initialHeight * 0.75}px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding-bottom: ${({ theme }) => theme.initialHeight}px;
  }
`

export default DaylightChartScroll
